<template>
  <div class="transformer-dist-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex>$<strong>公式：</strong>U1/U2 = n1/n2 | P_loss = I²R$</div>
    </div>

    <div class="main-layout vertical">
      <div class="canvas-box simulation">
        <svg width="100%" height="240" viewBox="0 0 400 240">
          <!-- Power Plant -->
          <rect x="20" y="100" width="40" height="40" fill="#333" stroke="#555" />
          <text x="15" y="155" fill="#888" font-size="8">发电站 (U1)</text>

          <!-- High Voltage Line -->
          <line x1="60" y1="120" x2="160" y2="120" stroke="#ffd700" stroke-width="2" />
          <text x="80" y="110" fill="#ffd700" font-size="8">高压输电 ({{ lineVoltage }}kV)</text>

          <!-- Step-down Transformer -->
          <g transform="translate(160, 100)">
             <rect x="0" y="0" width="60" height="40" rx="5" fill="rgba(0,111,253,0.1)" stroke="#00d2ff" />
             <!-- Coils -->
             <path d="M 5,5 Q 15,20 5,35" fill="none" stroke="#ffd700" stroke-width="2" />
             <path d="M 55,10 Q 45,20 55,30" fill="none" stroke="#fff" stroke-width="1.5" />
          </g>
          <text x="160" y="155" fill="#00d2ff" font-size="8">降压变压器 (n1 > n2)</text>

          <!-- User End -->
          <line x1="220" y1="120" x2="320" y2="120" stroke="#fff" stroke-width="1" />
          <g transform="translate(320, 100)">
             <rect x="0" y="0" width="40" height="40" fill="#333" stroke="#555" />
             <path v-if="userVoltage > 0" d="M 10,20 L 30,20 M 20,10 L 20,30" stroke="#ffd700" stroke-width="2" />
          </g>
          <text x="320" y="155" fill="#888" font-size="8">用户端 ({{ userVoltage }}V)</text>

          <!-- Loss Warning -->
          <text v-if="lineVoltage < 20" x="80" y="135" fill="#ff4757" font-size="8">⚠️ 输电损耗巨大</text>
        </svg>

        <div class="hud-top">
           <div class="stat">
              <label>电压比 U1:U2 = {{ ratio }}:1</label>
           </div>
        </div>
      </div>

      <div class="bottom-controls">
        <div class="control-card glass">
          <div class="row">
             <label>调节输电电压 U_high: {{ lineVoltage }} kV</label>
             <el-slider v-model="lineVoltage" :min="10" :max="220" size="mini"></el-slider>
          </div>
          <div class="row">
             <label>变压器匝数比 n1/n2: {{ ratio }}</label>
             <el-slider v-model="ratio" :min="10" :max="100" size="mini"></el-slider>
          </div>
        </div>

        <div class="discovery-note" v-latex>
          <p><strong>物理详解：</strong>远距离输电通过**高压**减小电流，从而大幅降低导线上的热损耗（$P=I^2R$）。到达目的地后，必须通过**降压变压器**将电压降低到 220V 安全使用水平。匝数比决定了降压的幅度。</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StepDownTransformerViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      lineVoltage: 110,
      ratio: 50
    }
  },
  computed: {
    userVoltage() {
      return Math.round((this.lineVoltage * 1000) / this.ratio);
    }
  }
}
</script>

<style scoped lang="scss">
.transformer-dist-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.canvas-box { background: #020205; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05); }
.bottom-controls { flex: 0.6; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; 
  label { font-size: 0.7rem; color: #888; display: block; margin-bottom: 5px; } 
}
.discovery-note { background: rgba(0, 111, 253, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
